import React, { PureComponent } from 'react';

import PropTypes from 'prop-types';
import classNames from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles'
// eslint-disable-next-line css-modules/no-unused-class
import style from './Button.scss';
import { withRtl } from '../hoc';

class Button extends PureComponent {
  static propTypes = {
    children: PropTypes.oneOfType([PropTypes.bool, PropTypes.node]),
    disabled: PropTypes.bool,
    full: PropTypes.bool,
    blueFont: PropTypes.bool,
    iconTop: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
    iconLeft: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
    iconRight: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
    iconColor: PropTypes.string,
    label: PropTypes.node.isRequired,
    ariaLabel: PropTypes.string,
    large: PropTypes.bool,
    small: PropTypes.bool,
    largeLong: PropTypes.bool,
    onClick: PropTypes.func.isRequired,
    onKeyDown: PropTypes.func,
    secondary: PropTypes.bool,
    attachTop: PropTypes.bool,
    attachRight: PropTypes.bool,
    attachBottom: PropTypes.bool,
    attachLeft: PropTypes.bool,
    uppercase: PropTypes.bool,
    customClass: PropTypes.string,
  };
  static defaultProps = {
    blueFont: false,
    children: false,
    disabled: false,
    full: false,
    iconTop: false,
    iconLeft: false,
    iconRight: false,
    iconColor: '#fff',
    // label: 'Submit',
    ariaLabel: '',
    large: false,
    small: false,
    largeLong: false,
    onKeyDown: null,
    secondary: false,
    // attach: 'None',
    attachTop: false,
    attachRight: false,
    attachBottom: false,
    attachLeft: false,
    uppercase: false,
    customClass: '',
  };

  render() {
    const {
      blueFont,
      children,
      disabled,
      full,
      iconColor,
      iconTop,
      iconLeft,
      iconRight,
      large,
      small,
      largeLong,
      label,
      ariaLabel,
      onClick,
      onKeyDown,
      secondary,
      customClass,
      // attach,
      attachTop,
      attachRight,
      attachBottom,
      attachLeft,
      uppercase,
      buttonType,
    } = this.props;
    const className = classNames(
      style.root,
      { [style.disabled]: disabled },
      { [style.full]: full },
      { [style.secondary]: secondary },
      { [style.blueFont]: blueFont },
      { [style.attachTop]: attachTop },
      { [style.attachRight]: attachRight },
      { [style.attachBottom]: attachBottom },
      { [style.attachLeft]: attachLeft },
      { [style.small]: small },
      { [style.uppercase]: uppercase },
      customClass,
    );
    const textClass = classNames(style.text, { [style.textLarge]: large, [style.textLargeLong]: largeLong });
    const click = disabled ? null : onClick;
    return (
      <button
        aria-label={ariaLabel || label}
        className={className}
        onClick={click}
        onKeyDown={onKeyDown}
        disabled={disabled}
        {...(buttonType && { 'type': buttonType })}
      >
        {children && children}
        {!children && (
          <span className={textClass}>
            {iconLeft && (
              <i
                style={{
                  color: iconColor,
                }}
                className={`${style.iconLeft} icon-${iconLeft}`}
                role="presentation"
              />
            )}
            {iconTop && (
              <i
                style={{
                  color: iconColor,
                }}
                className={`${style.iconTop} icon-${iconTop}`}
                role="presentation"
              />
            )}
            {label}
            {iconRight && (
              <i
                style={{
                  color: iconColor,
                }}
                className={`${style.iconRight} icon-${iconRight}`}
                role="presentation"
              />
            )}
          </span>
        )}
      </button>
    );
  }
}

export default withRtl(style)(withStyles(style)(Button));
